import { DatePicker, Form, Input, message, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import rpmService from "../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import { fetchRpmDevicesList } from "../../../../../Redux/actions/rpmActions";
import { convertUTCDate } from "../../../../../utils/convertionFunc";

function AddDevices({ handleNewDeviceMod, handlSetLocalMappedDevices }) {
  const [loader, setLoader] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const formRef = useRef();
  const { isLoading, devicesList } = useSelector((state) => state.rpm);
  const { selectedEditPatient } = useSelector((state) => state.patients);
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const connectivityOptions = [
    { name: "Manual", value: "Manual" },
    { name: "Bluetooth", value: "Bluetooth" },
  ];

  useEffect(() => {
    const payload = {
      status: 1,
    };
    dispatch(fetchRpmDevicesList(payload));
  }, []);

  const handleDevicePatientMap = () => {
    const {
      brand,
      deviceCode,
      deviceDemo,
      connectivity,
      issuedDate,
      model,
      serialNumber,
      serviceFrom,
      serviceTo,
    } = formRef.current.getFieldValue();

    if (
      !brand ||
      !deviceCode ||
      !deviceDemo ||
      !connectivity ||
      !issuedDate ||
      !model ||
      !serialNumber ||
      !serviceFrom ||
      !serviceTo
    ) {
      message.error("Please fill in mandatory fields");
      return;
    }

    setLoader(true);
    const payload = {
      deviceCode,
      brand,
      model,
      serialNumber,
      connectivity,
      issuedDate: convertUTCDate(issuedDate, "YYYY-MM-DD HH:mm:ss"),
      deviceDemo,
      serviceFrom: convertUTCDate(serviceFrom, "MM/DD/YYYY"),
      serviceTo: convertUTCDate(serviceTo, "MM/DD/YYYY"),
      name: selectedDevice.name,
      createdBy: loggedUser?.user?.userId,
      deliveredOn: convertUTCDate(serviceTo, "MM/DD/YYYY"),
    };

    if (selectedEditPatient) {
      payload.patientCode = selectedEditPatient.patientId;
    }
    handlSetLocalMappedDevices(payload);
    handleNewDeviceMod();
    setLoader(false);

    // try {
    //     await rpmService.devicePatientMapping(payload);
    //     setLoader(false);
    // }
    // catch (e) {
    //     console.error(e);
    //     setLoader(false);
    // }
  };

  const handleSelectedDevice = (deviceCode) => {
    const item = devicesList.find((d) => d.code === deviceCode);
    if (!item) return;

    setSelectedDevice(item);
    formRef.current.setFieldsValue({
      brand: item.brand,
      model: item.model,
      serialNumber: item.serialNumber,
    });
  };

  return (
    <>
      <Form layout="vertical" ref={formRef}>
        <div className="grid grid-cols-2 items-center gap-4">
          <div>
            <Form.Item
              label={
                <span>
                  Devices <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="deviceCode"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                showSearch
                allowClear
                onChange={handleSelectedDevice}
                options={devicesList.map((item, idx) => {
                  return {
                    label: item.name,
                    value: item.code,
                    key: idx,
                  };
                })}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Brand <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="brand"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Model <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="model"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Serial No <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serialNumber"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Connectivity <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="connectivity"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                options={connectivityOptions.map((item, idx) => {
                  return {
                    label: item.name,
                    value: item.value,
                    key: idx,
                  };
                })}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Issued Date <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="issuedDate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Demo Given? <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="deviceDemo"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                options={["Yes", "No"].map((item, idx) => {
                  return {
                    label: item,
                    value: item,
                    key: idx,
                  };
                })}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Service From <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serviceFrom"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Service To <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serviceTo"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleNewDeviceMod}
          className="border-brand-primaryColor border rounded text-brand-primaryColor text-sm px-6 py-1.5"
        >
          Cancel
        </button>
        <button
          disabled={loader}
          onClick={handleDevicePatientMap}
          className="bg-brand-primaryColor text-brand-White border-brand-primaryColor border rounded px-5 py-1.5 text-brand-textWhite text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default AddDevices;
